import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

import { Account } from '../../../Enum/Filters/';
import { Filter } from '../../../Enum/Filters';

import { filterChanged } from '../../../Store/Filter/action';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const AccountFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.Account);

    const selectAccount = useCallback(
        (account: Account): void => {
            dispatch(filterChanged(Filter.Account, account));
        },
        [dispatch],
    );

    return (
        <>
            <Form className="account-filter" autoComplete="off">
                <Form.Group controlId="account">
                    <Form.Label>Betaalrekening</Form.Label>
                    <InputGroup>
                        <Form.Check
                            custom
                            checked={value === Account.Ja}
                            onChange={() => selectAccount(Account.Ja)}
                            type="radio"
                            label="Ja"
                            id="accountFilter1"
                        />
                        <Form.Check
                            custom
                            checked={value === Account.Nee}
                            onChange={() => selectAccount(Account.Nee)}
                            type="radio"
                            label="Nee"
                            id="accountFilter2"
                        />
                    </InputGroup>
                </Form.Group>
            </Form>
        </>
    );
};

export default AccountFilter;
